/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRun {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRun.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRun>): WellArchitectedFrameworkAssessmentRun {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRun(), model);
        WellArchitectedFrameworkAssessmentRun.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRun>): WellArchitectedFrameworkAssessmentRun {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRun.newInstance(<WellArchitectedFrameworkAssessmentRun> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRun) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRun.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRun): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRun.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.assessment_definition) {
            models.RecordIdentity.fixupPrototype(this.assessment_definition);
        }
        if (this.assessment_version) {
            models.RecordIdentity.fixupPrototype(this.assessment_version);
        }
        if (this.workload_version) {
            models.RecordIdentity.fixupPrototype(this.workload_version);
        }
    }

    /**
     * ID of the Assessment run
     */
    sysId: string;

    /**
     * Assessment run created on
     */
    createdOn: Date;

    /**
     * Assessment run updated on
     */
    updatedOn: Date;

    /**
     * Status of the assessment run
     */
    status: models.WellArchitectedFrameworkAssessmentRunStatus;

    /**
     * The Assessment this run is for
     */
    assessment_definition: models.RecordIdentity;

    /**
     * The version of the Assessment used for this run
     */
    assessment_version: models.RecordIdentity;

    /**
     * The version of the Workload used for this run
     */
    workload_version: models.RecordIdentity;

    /**
     * ARN of workload created when synced to AWS
     */
    hyperscaler_workload_id: string;

    /**
     * Sync failure reason
     */
    sync_failure_reason: string;

}
